import React, { useContext } from "react"
import SiteContext from "../contexts/SiteContext"

import enderecosVazios from "../assets/endereco-flat.svg"

import Divider from "@material-ui/core/Divider"
import { useTheme } from "@material-ui/core/styles"

import {
    Bairros,
    CadastrarEnderecoCliente,
    CalculaEnderecoUsuarioSemUsuario,
    CidadesAtendidasPorAplicativo,
    ComumCep,
    Post_ListarEstabelecimentosPorEndereco,
    RegistrarLogErro,
} from "../services/functions"

import Button from "@material-ui/core/Button"
import TextField from "@material-ui/core/TextField"
import Typography from "@material-ui/core/Typography"
import { Col, Row } from "react-bootstrap"
import { CalculosContext } from "../contexts/CalculosContext"

import Checkbox from "@material-ui/core/Checkbox"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import CheckBoxIcon from "@material-ui/icons/CheckBox"
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank"

import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import FormControl from "@material-ui/core/FormControl"
import IconButton from "@material-ui/core/IconButton"
import InputLabel from "@material-ui/core/InputLabel"
import MenuItem from "@material-ui/core/MenuItem"
import Select from "@material-ui/core/Select"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"

import useMediaQuery from "@material-ui/core/useMediaQuery"
import { TextosContext } from "../contexts/TextosContext"
import DialogNovoEndereco from "../pages/Delivery/DialogNovoEndereco"
import GoogleMapsAutocompleteInput from "./GoogleMapsAutocompleteInput"

export default function CadastroEndereco(props) {
    const {
        aplicativoDados,
        setAplicativoDados,
        loading,
        setLoading,
        carrinho,
        cardapio,
        usuarioLogado,
        setUsuarioLogado,
        continuarSemCadastro,
        // setContinuarSemCadastro,
        enderecoAtual,
        setEnderecoAtual,
    } = useContext(SiteContext)
    const { textos } = useContext(TextosContext)
    const { calcularValorTotal } = useContext(CalculosContext)

    const {
        telaDeEstabelecimentos = false,
        telaDeCardapio = false,
        estabelecimentoAtual,
        alertStart,
        DialogConfirmacaoinformacoes,
        retirarNoLocal,
        setInformacoesPedido,
        setVerTodasAsLojas,
        filtroTipoRetirada,
        listarEstabelecimentosPorEndereco,
        abrirAdicionarEndereco,
        setAbrirAdicionarEndereco,
        popUpCep,
        setPopUpCep,
        buscarCardapio,
        estabelecimentoDesejado,
        setInformacoesDoTipoEntrega,
        DialogFormaDePagamento,
        setEstabelecimentos,
    } = props

    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"))

    const [cep, setCep] = React.useState("")
    const [uf, setUf] = React.useState("")
    const [cidade, setCidade] = React.useState("")
    const [bairro, setBairro] = React.useState("")
    const [rua, setRua] = React.useState("")
    const [numero, setNumero] = React.useState("")
    const [complemento, setComplemento] = React.useState("")
    const [referencia, setReferencia] = React.useState("")
    const [naoSeiCep, setNaoSeiCep] = React.useState(false)
    const [cidades, setCidades] = React.useState(null)
    const [bairrosCepUnico, setBairrosCepUnico] = React.useState([])
    const [bairroCepUnicoSelecionado, setBairroCepUnicoSelecionado] = React.useState("")

    const [abrirNovoEndereco, setAbrirNovoEndereco] = React.useState(false)
    const [cepFoiCadastrado, setCepFoiCadastrado] = React.useState(false)
    const [enderecoCadastrado, setEnderecoCadastrado] = React.useState(false)

    console.log("bairrosCepUnico", bairrosCepUnico)

    const limparEnderecos = () => {
        setCep("")
        setUf("")
        setCidade("")
        setBairro("")
        setRua("")
        setNumero("")
        setComplemento("")
        setReferencia("")
        setBairrosCepUnico("")
        setCidades(null)
        setNaoSeiCep(false)
        setBairroCepUnicoSelecionado("")
    }

    const verificarDadosCadastroEndereco = () => {
        if (bairrosCepUnico.length && !bairro) {
            alertStart("Necessario a escolha do bairro!", "warning")
            return false
        } else if (cidades?.length && !cidade) {
            alertStart("Necessario a escolha da cidade!", "warning")
            return false
        } else if (!uf) {
            alertStart("Necessario o preenchimento da sigla do estado!", "warning")
            document.getElementById("cadastroUf").focus()
            return false
        } else if (!cidade) {
            alertStart("Necessario o preenchimento da cidade!", "warning")
            document.getElementById("cadastroCidade").focus()
            return false
        } else if (!bairro) {
            alertStart("Necessario o preenchimento do bairro!", "warning")
            document.getElementById("cadastroBairro").focus()
            return false
        } else if (!rua) {
            alertStart("Necessario o preenchimento da rua!", "warning")
            document.getElementById("cadastroRua").focus()
            return false
        } else if (!numero) {
            alertStart(
                `Necessário o preenchimento ${
                    aplicativoDados.tipoEndereco ? "da quadra e do lote" : "do número"
                }!`,
                "warning"
            )
            document.getElementById("cadastroNumero").focus()
            return false
        }
    }

    const criarEndereco = () => {
        const data = {
            //"idCliente": usuarioLogado.cliente.id,
            //"idEstabelecimento": estabelecimentoAtual.id,
            cep: cep,
            uf: uf,
            cidade: cidade,
            bairro: bairro,
            logradouro: rua,
            numero: numero,
            complemento: complemento,
            referencia: referencia,
            appNome: aplicativoDados.appNome,
            latitude: 0,
            longitude: 0,
            token: `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`,
        }

        if (aplicativoDados.tipoEntregaBairro == 1) {
            localStorage.removeItem("bairroEspecifico")
            data.bairroEspecifico = 1
        } else {
            data.bairroEspecifico = 0
        }

        return data
    }

    const permiteRetiradaBalcao = () => {
        return aplicativoDados?.permiteRetiradaBalcao || estabelecimentoAtual?.permiteRetiradaBalcao
    }

    const cadastroEnderecoCardapio = async () => {
        console.log("cadastroEnderecoCardapio")
        let deuCerto = false
        const data = criarEndereco()
        try {
            if (continuarSemCadastro && (!retirarNoLocal || naoSeiCep === true)) {
                if (verificarDadosCadastroEndereco() === false) return false
                setLoading(true)

                data.token = `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`
                data.appNome = aplicativoDados.appNome

                const enderecoComTaxa = await CalculaEnderecoUsuarioSemUsuario(
                    { endereco: data, estabelecimentoAtual: estabelecimentoAtual },
                    aplicativoDados
                )

                if (enderecoComTaxa.retornoErro) {
                    alertStart(retorno.mensagem, "error")
                    setLoading(false)
                    return
                }

                const retorno = await Post_ListarEstabelecimentosPorEndereco(
                    enderecoComTaxa,
                    aplicativoDados
                )

                if (retorno.retornoErro) {
                    alertStart(retorno.mensagem, "error")
                    setLoading(false)
                    return
                }

                console.log("Post_ListarEstabelecimentosPorEndereco", retorno)
                const estabelecimentosQueEntregam = retorno.filter(
                    estabelecimento => estabelecimento.taxaEntrega != -1
                )
                const estabelecimentoAtualComTaxa = estabelecimentosQueEntregam.filter(
                    estabelecimento => estabelecimento.id === estabelecimentoAtual.id
                )

                if (estabelecimentoAtualComTaxa.length) {
                    data.taxaEntrega = estabelecimentoAtualComTaxa[0].taxaEntrega
                    deuCerto = true
                } else {
                    data.taxaEntrega = -1
                    if (estabelecimentosQueEntregam.length) {
                        alertStart(
                            `Este estabelecimento não entrega no endereço cadastrado. Porém, outro estabelecimento entrega em seu endereço!`,
                            "error"
                        )
                    } else {
                        alertStart(
                            `Este estabelecimento não entrega no endereço cadastrado.`,
                            "error"
                        )
                    }
                    setInformacoesDoTipoEntrega(false)
                    DialogFormaDePagamento(false)
                }

                await calcularValorTotal({
                    carrinho: {
                        ...carrinho,
                        minimoEntregaGratis: enderecoComTaxa.minimoEntregaGratis,
                    },
                    cardapio,
                    enderecoAtual: enderecoComTaxa,
                })
            }

            setAbrirAdicionarEndereco(false)
            if (deuCerto) DialogConfirmacaoinformacoes(true)
        } catch (error) {
            RegistrarLogErro(error, "cadastroEnderecoCardapio", data)
            alertStart("Procure os desenvolvedores " + error.message, "error")
            setLoading(false)
            setAbrirAdicionarEndereco(false)
        }

        setLoading(false)

        limparEnderecos()
    }
    const buscarLojasQueEntregam = async () => {
        if (verificarDadosCadastroEndereco() === false) return false

        setVerTodasAsLojas(false)
        setAbrirAdicionarEndereco(false)
        setLoading(true)

        try {
            const data = criarEndereco()

            if (usuarioLogado?.logado) {
                await cadastrarEnderecoNoUsuario(data)
            } else {
                setEnderecoAtual(data)
                listarEstabelecimentosPorEndereco(data)
            }
        } catch (error) {
            RegistrarLogErro(error, "ListarEstabelecimentosPorEndereco")
            alertStart("Procure os desenvolvedores " + error.message, "error")
            setLoading(false)
            setAbrirAdicionarEndereco(false)
        }

        limparEnderecos()
    }

    const cadastrarEnderecoNoUsuario = async data => {
        try {
            data.idCliente = usuarioLogado.cliente.id

            if (aplicativoDados.tipoEntregaBairro == 1) {
                data.bairroEspecifico = 1
            } else {
                data.bairroEspecifico = 0
            }

            const retorno = await CadastrarEnderecoCliente(data, aplicativoDados)

            console.log("CadastrarEnderecoCliente", retorno)
            if (retorno.retornoErro) {
                alertStart(retorno.mensagem, "error")
                listarEstabelecimentosPorEndereco(data)
                setLoading(false)
            } else {
                if (!usuarioLogado.cliente.enderecos) {
                    usuarioLogado.cliente.enderecos = []
                }
                usuarioLogado.cliente.enderecos.push(retorno)

                setUsuarioLogado(usuarioLogado)

                setEnderecoAtual(retorno)
                listarEstabelecimentosPorEndereco(retorno) //data com id
            }
        } catch (error) {
            RegistrarLogErro(error, "cadastrarEnderecoNoUsuario", data)
            alertStart("Procure os desenvolvedores!. Erro: " + error.message, "error")
        }
    }

    const nextFocus = (e, id, click = false) => {
        if (e.keyCode == 13 || e.keyCode == 9) {
            if (click) {
                document.getElementById(`${id}`).click()
            } else {
                document.getElementById(`${id}`).focus()
            }
        }
    }

    const verificarCep = async e => {
        let valorInput = e.target.value
        try {
            valorInput = valorInput.replace(/-/g, "")
            valorInput = valorInput.replace(/ /g, "")
            valorInput = valorInput.replace(/\//g, "")
            // valorInput = valorInput.substring(0,8)
            console.log("valorInput", valorInput)
            if (valorInput.length == 8) {
                setCep(valorInput)
                setLoading(true)
                //buscar dados do cep
                const retornoCep = await ComumCep(valorInput, aplicativoDados)

                console.log("retornoCep", retornoCep)
                if (retornoCep.retornoErro) {
                    alertStart(retornoCep.mensagem, "error")
                } else {
                    if (retornoCep.id || retornoCep.logradouro) {
                        setBairrosCepUnico("")
                        setBairro(retornoCep.bairro)
                        setCidade(retornoCep.localidade)
                        setRua(retornoCep.logradouro)
                        setUf(retornoCep.uf)
                        setPopUpCep(false)
                        setAbrirAdicionarEndereco(true)
                    } else if (retornoCep.bairros && retornoCep.bairros.length >= 1) {
                        setBairrosCepUnico(retornoCep.bairros)
                        setPopUpCep(false)
                        setAbrirAdicionarEndereco(true)
                    } else {
                        //DEU ERRO, OU NAO EXISTE
                        alertStart("CEP não encontrado", "error")
                        // setAbrirAdicionarEndereco(false)
                        limparEnderecos()

                        if (popUpCep) {
                            document.getElementById("cepDigitando2").value = ""
                            document.getElementById("cepDigitando2").focus()
                        } else {
                            document.getElementById("cepDigitando").value = ""
                            document.getElementById("cepDigitando").focus()
                        }
                    }
                }

                setLoading(false)
            }
        } catch (error) {
            RegistrarLogErro(error, "verificarCep", valorInput)
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const selecionarRetirada = async value => {
        if (telaDeEstabelecimentos) {
            filtroTipoRetirada(false)
            setAbrirAdicionarEndereco(false)
        } else if (telaDeCardapio) {
            if (value) {
                setAbrirAdicionarEndereco(false)
                DialogConfirmacaoinformacoes(true)
                await calcularValorTotal({
                    carrinho,
                    cardapio,
                    enderecoAtual: {
                        id: "retirada",
                    },
                })
            } else {
                await calcularValorTotal({
                    carrinho,
                    cardapio,
                    enderecoAtual: {
                        taxaEntrega: -1,
                    },
                })
            }
        }
    }

    const NaoSeiCep = async e => {
        setLoading(true)
        limparEnderecos()
        setNaoSeiCep(true)
        try {
            const retorno = await CidadesAtendidasPorAplicativo(
                { appNome: aplicativoDados.appNome },
                aplicativoDados
            )
            console.log("CidadesAtendidasPorAplicativo", retorno)
            if (retorno?.retornoErro) {
                alertStart(retorno?.mensagem, "error")
                setLoading(false)
            } else {
                setCep("00000000")
                setCidades(retorno)
                alterarCidade(retorno, retorno[0].nome)
            }
        } catch (error) {
            RegistrarLogErro(error, "CidadesAtendidasPorAplicativo")
            alertStart("Erro não identificado ao buscar CidadesAtendidasPorAplicativo", "error")
            setLoading(false)
        }
    }

    const alterarCidade = async (cidades, nome) => {
        setLoading(true)
        try {
            const cidade = cidades?.filter(c => c.nome == nome)[0]
            const retorno = await Bairros(cidade, aplicativoDados)
            if (retorno.retornoErro) {
                alertStart(retorno.mensagem, "error")
            } else {
                setCidade(cidade.nome)
                setBairrosCepUnico(retorno)
                setBairro("")
                setBairroCepUnicoSelecionado("")
                setPopUpCep(false)
                setUf(cidade.estado.sigla)
                // setBairrosCepUnico(retorno.data)
                // setCep("00000000");
                // setBairroCepUnicoSelecionado(0)
            }
        } catch (error) {
            RegistrarLogErro(error, "CidadesAtendidasPorAplicativo", nome)
            alertStart("Erro não identificado ao buscar CidadesAtendidasPorAplicativo", "error")
        }
        setLoading(false)
    }

    const usarGoogleMapsAPI = aplicativoDados.tipoSelecaoEndereco === 1
    const usarMapBoxAPI = aplicativoDados.tipoSelecaoEndereco === 2

    return (
        <>
            {telaDeEstabelecimentos && (
                <Row
                    style={
                        enderecoAtual?.logradouro || retirarNoLocal
                            ? { display: "none" }
                            : undefined
                    }
                >
                    <Col xs={12} md={12} lg={12}>
                        <Typography gutterBottom variant="h6">
                            Digite seu {usarGoogleMapsAPI ? "endereço" : "CEP"} para entrega
                        </Typography>
                    </Col>

                    <Col xs={12} md={6} lg={6} style={{ margin: "0 auto" }}>
                        {usarGoogleMapsAPI ? (
                            <GoogleMapsAutocompleteInput
                                fullWidth
                                setEnderecoCadastrado={setEnderecoCadastrado}
                                setCepFoiCadastrado={setCepFoiCadastrado}
                                setAbrirNovoEndereco={setAbrirNovoEndereco}
                                setLoading={setLoading}
                                ComumCep={ComumCep}
                                alertStart={alertStart}
                            />
                        ) : (
                            <TextField
                                disabled={retirarNoLocal}
                                style={{ width: "300px", maxWidth: "100%", background: "white" }}
                                name="CEP"
                                id="cepDigitando"
                                label="CEP"
                                // onKeyUp={nextFocus("")}
                                type="number"
                                onChange={verificarCep}
                                variant="outlined"
                            />
                        )}
                    </Col>
                    <Col xs={12} md={12} lg={12}>
                        <FormControlLabel
                            style={
                                permiteRetiradaBalcao()
                                    ? { margin: "0 0 0 0" }
                                    : { visibility: "hidden", maxHeight: "0.5rem" }
                            }
                            checked={retirarNoLocal}
                            control={
                                <Checkbox
                                    id="botaoRetirada"
                                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                    name="retirarNoLocal"
                                    onClick={() => filtroTipoRetirada(false)}
                                />
                            }
                            label="Retirar no Local"
                        />
                    </Col>
                    <Divider style={{ width: "100%", margin: "0 0 1em 0" }} />
                </Row>
            )}

            <Dialog
                fullScreen={fullScreen}
                // fullScreen={true}
                fullWidth={true}
                maxWidth={"md"}
                open={abrirAdicionarEndereco}
                aria-labelledby="codigoIndicacao"
            >
                {!fullScreen ? <img src={aplicativoDados.urlLogo} className="imgModal" /> : null}
                <DialogTitle id="codigoIndicacao">
                    <IconButton
                        className="setaVoltarModal"
                        onClick={() => {
                            // setAbrirAdicionarEndereco(false)
                            limparEnderecos()
                            setAbrirAdicionarEndereco(false)
                            if (popUpCep) {
                                setTimeout(() => {
                                    setPopUpCep(false)
                                }, 500)
                            }
                        }}
                    >
                        <ArrowForwardIosIcon />
                    </IconButton>
                    {textos.adicionarEndereco}
                </DialogTitle>

                <DialogContent>
                    <Row>
                        {popUpCep ? (
                            <React.Fragment>
                                <Col xs={12} md={12} lg={12} style={{ marginTop: "1em" }}>
                                    <TextField
                                        // disabled={retirarNoLocal}
                                        fullWidth
                                        onFocus={() => {
                                            if (retirarNoLocal === true) {
                                                selecionarRetirada()
                                            }
                                        }}
                                        name="CEP"
                                        //value={cep}
                                        id="cepDigitando2"
                                        // onKeyUp={nextFocus("")}
                                        label="CEP"
                                        onChange={verificarCep}
                                        variant="outlined"
                                    />
                                </Col>
                                <Col xs={12} md={6} lg={6} className="mt-2 text-center">
                                    <Button variant="contained" onClick={NaoSeiCep} color="default">
                                        Não Sei CEP
                                    </Button>
                                </Col>
                                {console.log(
                                    "AplicativoooV1",
                                    aplicativoDados?.permiteRetiradaBalcao
                                )}
                                {console.log(
                                    "AplicativoooV2",
                                    estabelecimentoAtual?.permiteRetiradaBalcao
                                )}
                                {console.log("AplicativoooV3", permiteRetiradaBalcao())}
                                {permiteRetiradaBalcao() && (
                                    <Col xs={12} md={6} lg={6} className="mt-2 text-center">
                                        <FormControlLabel
                                            style={{ margin: "0 0 0 0" }}
                                            checked={retirarNoLocal}
                                            control={
                                                <Checkbox
                                                    id="botaoRetirada2"
                                                    icon={
                                                        <CheckBoxOutlineBlankIcon fontSize="small" />
                                                    }
                                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                    name="retirarNoLocal2"
                                                    onClick={() => {
                                                        var valorChek = JSON.parse(
                                                            JSON.stringify(retirarNoLocal)
                                                        )
                                                        selecionarRetirada(!valorChek)
                                                    }}
                                                />
                                            }
                                            label="Retirar no Local"
                                        />
                                    </Col>
                                )}

                                <div className="divImageCentroCardapio">
                                    <img
                                        alt={"sem endereços cadastrados"}
                                        src={enderecosVazios}
                                        className="pretoEBranco"
                                    />
                                </div>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                {cidades ? (
                                    <Col xs={12} md={12} lg={12}>
                                        <FormControl
                                            variant="outlined"
                                            style={{ width: "100%", margin: "0.5em 0" }}
                                        >
                                            <InputLabel id="demo-simple-select-outlined-label">
                                                Cidades
                                            </InputLabel>
                                            <Select
                                                labelId="demo-simple-select-outlined-label"
                                                fullWidth
                                                id="cadastroBairro"
                                                value={cidade}
                                                onChange={e => {
                                                    alterarCidade(cidades, e.target.value)
                                                }}
                                                label="Cidades"
                                            >
                                                {cidades?.map((cidade, index) => (
                                                    <MenuItem key={cidade.id} value={cidade.nome}>
                                                        {cidade.nome} - {cidade.estado.sigla}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Col>
                                ) : null}
                                {bairrosCepUnico ? (
                                    <Col xs={12} md={12} lg={12}>
                                        <FormControl
                                            variant="outlined"
                                            style={{ width: "100%", margin: "0.5em 0" }}
                                        >
                                            <InputLabel id="demo-simple-select-outlined-label">
                                                Bairros do Cep
                                            </InputLabel>
                                            <Select
                                                labelId="demo-simple-select-outlined-label"
                                                fullWidth
                                                id="cadastroBairro"
                                                value={bairroCepUnicoSelecionado}
                                                onChange={e => {
                                                    //console.log(e.target.value)
                                                    setBairroCepUnicoSelecionado(e.target.value)
                                                    setUf(
                                                        bairrosCepUnico[e.target.value].cidade
                                                            .estado.sigla
                                                    )
                                                    const cidadeBairro =
                                                        bairrosCepUnico[e.target.value].cidade.nome
                                                    const cidade = cidades?.length
                                                        ? cidades?.filter(
                                                              c => c.nome == cidadeBairro
                                                          )[0].nome
                                                        : cidadeBairro
                                                    setCidade(cidade)
                                                    setBairro(bairrosCepUnico[e.target.value].nome)
                                                }}
                                                label="Bairros do Cep"
                                            >
                                                {bairrosCepUnico.map((bairro, index) => (
                                                    <MenuItem key={bairro.id} value={index}>
                                                        {bairro.nome} - {bairro?.cidade?.nome}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Col>
                                ) : (
                                    <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                        <TextField
                                            disabled
                                            fullWidth
                                            required
                                            value={bairro}
                                            name="BAIRRO"
                                            id="cadastroBairro"
                                            label="BAIRRO"
                                            variant="outlined"
                                        />
                                    </Col>
                                )}
                                <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                    <TextField
                                        disabled
                                        fullWidth
                                        required
                                        value={uf}
                                        name="UF"
                                        id="cadastroUf"
                                        label="UF"
                                        variant="outlined"
                                    />
                                </Col>
                                {!cidades ? (
                                    <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                        <TextField
                                            required
                                            fullWidth
                                            disabled
                                            value={cidade}
                                            name="CIDADE"
                                            id="cadastroCidade"
                                            label="CIDADE"
                                            variant="outlined"
                                        />
                                    </Col>
                                ) : null}
                                <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                    <TextField
                                        required
                                        fullWidth
                                        //autoFocus={bairrosCepUnico.length ? true : false}
                                        disabled={bairrosCepUnico.length ? false : true}
                                        name="RUA"
                                        onKeyUp={e => nextFocus(e, "cadastroNumero")}
                                        onChange={e => {
                                            setRua(e.target.value)
                                        }}
                                        value={rua}
                                        id="cadastroRua"
                                        label="RUA"
                                        variant="outlined"
                                    />
                                </Col>
                                <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                    <TextField
                                        //autoFocus
                                        fullWidth
                                        required
                                        name={
                                            aplicativoDados.tipoEndereco
                                                ? "QUADRA E LOTE"
                                                : "NUMERO"
                                        }
                                        value={numero}
                                        onKeyUp={e => nextFocus(e, "cadastroComplemento")}
                                        onChange={e => {
                                            setNumero(e.target.value)
                                        }}
                                        id="cadastroNumero"
                                        label={
                                            aplicativoDados.tipoEndereco
                                                ? "QUADRA E LOTE"
                                                : "NUMERO"
                                        }
                                        variant="outlined"
                                        type={aplicativoDados.tipoEndereco ? "text" : "number"}
                                    />
                                </Col>
                                <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                    <TextField
                                        fullWidth
                                        value={complemento}
                                        onKeyUp={e => nextFocus(e, "cadastroReferencia")}
                                        onChange={e => {
                                            setComplemento(e.target.value)
                                        }}
                                        name="COMPLEMENTO"
                                        id="cadastroComplemento"
                                        label="COMPLEMENTO"
                                        variant="outlined"
                                    />
                                </Col>
                                <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                    <TextField
                                        fullWidth
                                        value={referencia}
                                        onChange={e => {
                                            setReferencia(e.target.value)
                                        }}
                                        onKeyUp={e => nextFocus(e, "buttonCadastroEndereco", true)}
                                        name="REFERENCIA"
                                        id="cadastroReferencia"
                                        label="REFERENCIA"
                                        variant="outlined"
                                    />
                                </Col>
                            </React.Fragment>
                        )}
                    </Row>
                </DialogContent>

                <DialogActions>
                    {telaDeEstabelecimentos ? (
                        !popUpCep ? (
                            <Button
                                id="buttonCadastroEndereco"
                                onClick={() => {
                                    buscarLojasQueEntregam()
                                }}
                                style={{ color: "#fff", backgroundColor: "#28a745" }}
                            >
                                Pronto
                            </Button>
                        ) : (
                            <Button
                                id="buttonCadastroEndereco"
                                onClick={() => {
                                    if (telaDeEstabelecimentos) {
                                        buscarCardapio(estabelecimentoDesejado)
                                    } else {
                                    }
                                }}
                                style={{ color: "#fff", backgroundColor: "#28a745" }}
                            >
                                Cardápio
                            </Button>
                        )
                    ) : (
                        telaDeCardapio &&
                        cep.length >= 8 && (
                            <Button
                                id="buttonCadastroEndereco"
                                onClick={() => {
                                    cadastroEnderecoCardapio()
                                }}
                                style={{ color: "#fff", backgroundColor: "#28a745" }}
                            >
                                Pronto
                            </Button>
                        )
                    )}
                </DialogActions>
            </Dialog>
            <DialogNovoEndereco
                abrirNovoEndereco={abrirNovoEndereco}
                setAbrirNovoEndereco={setAbrirNovoEndereco}
                abrirCEP={false}
                setAbrirCEP={() => {}}
                setAbrirEnderecos={() => {}}
                setTelaRetiradaOuEntrega={() => {}}
                cepFoiCadastrado={cepFoiCadastrado}
                setCepFoiCadastrado={setCepFoiCadastrado}
                alertStart={alertStart}
                enderecoCadastrado={enderecoCadastrado}
                continuarSemCadastro={continuarSemCadastro}
                estabelecimentoAtual={estabelecimentoAtual}
                buscarCardapio={buscarCardapio}
                setEstabelecimentos={setEstabelecimentos}
            />
        </>
    )
}
